export default __webpack_public_path__ + "static/media/B173.097f8dfa.png";